import { render } from "./CooperationFileUploadPage.vue?vue&type=template&id=bef911e8"
import script from "./CooperationFileUploadPage.vue?vue&type=script&lang=js"
export * from "./CooperationFileUploadPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__